import { Component, Injectable, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LocalisationService } from '@app/services/localisation.service';
import { DcdArticle } from '@app/models/dcd/article.model';

@Injectable()
export class ModalProvider {
  create: (
    title: string,
    message: string,
    clickHandler?: Function,
    confirmText?: string,
    youtubeId?: string,
    dcdArticle?: DcdArticle,
    balanceText?: boolean
  ) => Promise<boolean>;

  close: () => void;
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent {
  isOpen: boolean = false;
  title: string;
  message: string;
  callback: Function;
  confirmText: string;
  youtubeId: string;
  youtubeURL: any = null;
  dcdArticle: DcdArticle;
  balanceText: boolean = true;

  locale: any = {};

  resolve: (closed: boolean) => void;

  constructor(
    private modal: ModalProvider,
    private router: Router,
    private sanitizer: DomSanitizer,
    public localisation: LocalisationService
  ) {
    modal.create = this.create.bind(this);
    modal.close = this.close.bind(this);

    router.events.subscribe(val => {
      var currentUrl = this.router.url;
      if (this.isOpen && (val as any).url != currentUrl) {
        this.close();
      }
    });
  }

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('ModalComponent');
  }

  create(
    title: string,
    message: string,
    clickHandler: Function = null,
    confirmText: string = null,
    youtubeId: string = null,
    dcdArticle: DcdArticle,
    balanceText: boolean = true
  ) {
    this.title = title;
    this.message = message;
    this.callback = clickHandler;
    this.confirmText = confirmText;
    this.balanceText = balanceText;

    if (youtubeId !== null) {
      let url = 'https://www.youtube.com/embed/' + youtubeId;
      this.youtubeURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    this.dcdArticle = dcdArticle;

    return new Promise<boolean>(resolve => {
      this.open();
      this.resolve = resolve;
    });
  }

  addSafeURL(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  clickHandler() {
    this.callback.call([]);
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.youtubeURL = null;
    this.isOpen = false;
    this.title = this.message = '';
    this.resolve(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/modal/modal.component.ts